// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"646":"27c20388","940":"33ec3142"}[chunkId] + ".chunk.css";
};